module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"tip":"В свободной форме, это будет очень полезно для специалиста по подбору персонала.","refuse":"Отказаться","cancel":"Отмена","successMessage":"Спасибо за обратную связь. Мы больше не будем беспокоить вас по этой вакансии."}}')
  delete Component.options._Ctor
}
